
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DcrDrug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import * as constants from 'src/app/config/app-constants';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { routePaths } from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { ImportWizardDrugClassificationResolutionComponent } from './../import-wizard-drug-classification-resolution/import-wizard-drug-classification-resolution.component';

@Component({
  selector: 'app-import-wizard-dcr-drug-list',
  standalone: false,
  templateUrl: './import-wizard-dcr-drug-list.component.html',
  styleUrl: './import-wizard-dcr-drug-list.component.scss'
})
export class ImportWizardDcrDrugListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns = ['name','strength', 'drugNumber', 'priority','dcrAge', 'status', 'caseOwner', 'caseSource', 'manufacturer','caseNumber','action'];
  selectedRow:any;
  dataSource= new MatTableDataSource<DcrDrug>();
  totalRows: number = 0;
  currentPage: number = 0;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10, 50, 100, 200, 500];
  isCaseNoShow: boolean = false;
  listOfCaseOwnersForFilter = ['All', 'Lisa Eleby', 'Travis Morris', 'DCR Queue']
  caseOwner: string = 'All';
  name : string = '';
  drugNumber: string = '';

  searchText: string = '';
  selectedSearchCriteria: { key: string; label: string } = { key: 'ndc', label: 'Drug Number' };
  selectedCaseNo: string | null = null;

  searchCriteria = [
    { key: 'ndc', label: 'Drug Number' },
    { key: 'drugName', label: 'Drug Name' }
  ];

  constructor(
    public dialogRef: MatDialogRef<ImportWizardDcrDrugListComponent>,
    public dialog: MatDialog,
    private rpoService:RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
      this.caseOwner = data.caseOwner;
    }

  ngOnInit(): void {
    this.getDrugData();
  }
  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getDrugData();
  }
  getDrugData(){
    let dcrKey = 'dcrKey'
    this.ngxLoader.start(dcrKey);
    if(this.selectedSearchCriteria.key == "drugName"){
      this.name = this.searchText;
    }
    else{
      this.drugNumber = this.searchText;
    }
    this.rpoService.getDcrDrugs(
       this.currentPage,
       this.pageSize,
       this.caseOwner,
       this.drugNumber,
       this.name
    ).subscribe((response)=>{
      let result = response.data;
      this.ngxLoader.stop(dcrKey);
     this.dataSource.data = result.drugs
     setTimeout(() => {
      this.paginator.pageIndex = this.currentPage;
      this.paginator.length = result.totalRows;
    });
    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop(dcrKey);
      console.log(error);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  onCaseOwnerSelectionChange(owner: string) {
    this.caseOwner = owner;
    this.getDrugData();
  }

  onCriteriaSelect(criteria: { key: string; label: string }) {
    this.selectedSearchCriteria = criteria;
    if(this.searchText.length > 0){
      this.getDrugData();
    }
  }

  onSearchTextChange(value: string) {
    this.searchText = value;
    this.getDrugData();
  }



   openImportWizardDcrDetails(caseNo:any) {
      const dialogRef = this.dialog.open(ImportWizardDrugClassificationResolutionComponent, {
        backdropClass: ['lgDialog'],
        disableClose: true,
        data: {
          caseNo: caseNo
        }
      });

    }

}

